module.exports = __webpack_public_path__ + "media/images/common/ico_01_sp-0c0e0b6b603cff46108a2679432015fc.png";